export default __webpack_public_path__ + "static/48-ae1740c6b208e2963488a8af835fb5a8.png";